import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import firebase from '../../lib/firebase';
import { FarmaError, FarmaFuncaoError } from 'src/integracoes/modelos/erros';
import { authStateChanged, clearUserAuth, authErrorMsg, getEmpresaSuccess, getPaineisEmpresaAtualSuccess, clearPaineisEmpAtual, getPaineisUsuarioSuccess } from './actions';
import {
  USER_DATA_INIT,
  AUTH_STATE_CHANGED,
  GET_EMPRESA_INIT,
  GET_PAINEIS_EMPRESA_INIT,
  GET_PAINEIS_USUARIO_INIT
} from '../actionTypes';
import {
  obtemEmpresa,
  obtemPaineisEmpresa
} from 'src/integracoes/servicos/mongo-atlas/funcoes/empresas';
import { IUsuarioMongoDB } from 'src/integracoes/modelos/usuarios';
import { listPainelInit } from '../actions';
import { IEmpresa } from 'src/integracoes/servicos/mongo-atlas/modelos/IEmpresa';
import { listCategoriaPainelInit } from '../categorias/actions';
import { obtemPapelUsuario, obtemPaineisUsuario, obtemUsuario } from 'src/integracoes/servicos/mongo-atlas/funcoes/usuarios';
import { IPainelDadosCompletos } from 'src/integracoes/servicos/powerbi/modelos/IPainelDadosCompletos';
import { mapEmpresaParaMyEmp } from './mappers';

import { startSessionLogin } from 'src/integracoes/servicos/mongo-atlas/funcoes/sessionLogin';
import { v4 as uuidv4 } from 'uuid';
interface FetchPainelResult {
  isError: boolean;
  paineis: IPainelDadosCompletos[] | null;
  msg: string | null;
}

// -------------------- Buscar dados usuário -----------------------------------------
const obtemDadosUsuarioAtual = async (empId: string, firebaseId: string) => {
  try {

    const [respostaUsuarioAtual, respostaEmpresaAtual, respostaPrivilegeAtual, respostaPaineisUsuario] = await Promise.all([
      obtemUsuario(firebaseId),
      obtemEmpresa(empId),
      obtemPapelUsuario(firebaseId),
      obtemPaineisUsuario(firebaseId),
    ]);

    const conditions = [
      { status: respostaUsuarioAtual.status, errorData: respostaUsuarioAtual.dados },
      { status: respostaEmpresaAtual.status, errorData: respostaEmpresaAtual.dados },
      { status: respostaPrivilegeAtual.status, errorData: respostaPrivilegeAtual.dados },
      { status: respostaPaineisUsuario.status, errorData: respostaPaineisUsuario.dados }
    ];

    for (const condition of conditions) {
      if (!condition.status) {
        throw condition.errorData as FarmaFuncaoError;
      }
    }

    const usuarioAtual = respostaUsuarioAtual.dados as IUsuarioMongoDB;
    const empresaAtual = respostaEmpresaAtual.dados as any;
    const usuarioPapelAtual = respostaPrivilegeAtual.dados;
    const paineisUsuario = respostaPaineisUsuario.dados;

    const userData = {
      ...usuarioAtual,
      _id: usuarioAtual.id,
      id: usuarioAtual.firebaseId,
      paineis: paineisUsuario,
      myEmp: {}
    };

    userData.myEmp = mapEmpresaParaMyEmp({
      id: empresaAtual.id,
      status: empresaAtual.status,
      name: empresaAtual.name,
      identificador: empresaAtual.identificador,
      lojas: empresaAtual.lojas,
      grupos: empresaAtual.grupos,
      groupControl: empresaAtual.groupControl,
      indelible: false,
      config: empresaAtual.config,
      arquiteturaPbiAtiva: empresaAtual.arquiteturaPbiAtiva,
      arquiteturasPbi: empresaAtual.arquiteturasPbi
    });
    return {
      userData,
      usuarioPrivilegios: usuarioPapelAtual
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

export function* parseObtemDadosUsuarioAtual({ payload }: { payload: any; type: string }) {
  try {
    const { empId, firebaseId } = payload;
    const { userData, usuarioPrivilegios } = yield call(obtemDadosUsuarioAtual, empId, firebaseId);

    const deviceIdKey = 'device_session_id';

    let deviceId = localStorage.getItem(deviceIdKey);
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem(deviceIdKey, deviceId);
    }

    const sessionKey = `login_session_started_${deviceId}_${userData.id}`;
    const alreadyStarted = localStorage.getItem(sessionKey);

    // só cria sessão se ainda não existe em NENHUMA aba deste navegador
    if (!alreadyStarted) {
      yield call(startSessionLogin, {
        empId: userData.myEmp.id,
        entityType: 'login',
        entityId: userData.id,
        deviceId
      });

      localStorage.setItem(sessionKey, 'true');
    }

    yield put(
      authStateChanged({
        isAuthenticated: true,
        loading: false,
        user: userData,
        userPrivileges: usuarioPrivilegios
      })
    );
  } catch (error: any) {
    yield put(clearUserAuth());
    return firebase.auth().signOut();
  }
}

export function* handleGetUserData() {
  yield takeEvery(USER_DATA_INIT, parseObtemDadosUsuarioAtual);
}

// -------------------- Mudança de estado após Login -----------------------------------------
export function* parseAuthStateChange({ payload }: { payload: any; type: string }) {
  const { isAuthenticated } = payload;
  if (isAuthenticated) {
    try {
      yield put(listCategoriaPainelInit());
      yield put(listPainelInit());
    } catch (error) {
      const erro = {
        nome: 'AUTH_STATE_CHANGE',
        mensagem: 'Erro ao alterar o estado da autenticação do usuário',
        causa: error
      };
      throw new FarmaError(erro);
    }
  }
}

export function* handleAuthStateChange() {
  yield takeEvery(AUTH_STATE_CHANGED, parseAuthStateChange);
}

// -------------------- Buscar dados da Empresa Atual do sistema  -----------------------------------------
const fetchObtemEmpresa = async (empId: string): Promise<any> => {
  try {
    const { status, dados, mensagem } = await obtemEmpresa(empId);
    if (status) {
      return {
        isReceived: true,
        data: dados,
        msg: mensagem
      };
    } else {
      return {
        isReceived: false,
        data: {},
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

export function* parseObtemDadosEmpresa({ payload }: { payload: any; type: any }) {
  const { empId } = payload;
  try {
    const dados: {
      isReceived: boolean;
      data: IEmpresa;
      msg: string;
    } = yield call(fetchObtemEmpresa, empId);
    if (dados.isReceived) {
      yield put(
        getEmpresaSuccess({
          myEmp: mapEmpresaParaMyEmp(dados.data)
        })
      );
    } else {
      yield put(authErrorMsg({ msg: dados.msg }));
    }
  } catch (error: any) {
    yield put(authErrorMsg({ msg: error.mensagem }));
  }
}
export function* watchObtemDadosEmpresa() {
  yield takeEvery(GET_EMPRESA_INIT, parseObtemDadosEmpresa);
}

//------------------------- Obter paineis da empresa atual ---------------------------------------------

const fetchObtemPaineisEmpresaAtual = async (empId: string): Promise<FetchPainelResult> => {
  try {
    const { status, dados, mensagem } = await obtemPaineisEmpresa(empId);

    if (status && Array.isArray(dados)) {
      return {
        isError: false,
        paineis: dados,
        msg: mensagem
      };
    }
    return {
      isError: true,
      paineis: [],
      msg: mensagem
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseObtemPaineisEmpresaAtual({ payload }: { payload: any; type: string }) {
  try {
    const { paineis, msg, isError } = yield call(fetchObtemPaineisEmpresaAtual, payload);
    if (!isError) {
      yield put(getPaineisEmpresaAtualSuccess({ paineisEmpresaAtual: paineis, msg, isError }));
    } else {
      yield put(clearPaineisEmpAtual());
      yield put(authErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(clearPaineisEmpAtual());
    yield put(authErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchObtemPaineisEmpresaAtual() {
  yield takeEvery(GET_PAINEIS_EMPRESA_INIT, parseObtemPaineisEmpresaAtual);
}

//------------------------- Obter paineis do usuario ---------------------------------------------
const fetchObtemPaineisUsuario = async (firebaseId: string): Promise<any> => {
  try {
    const { status, dados, mensagem } = await obtemPaineisUsuario(firebaseId);
    if (status && Array.isArray(dados)) {
      return { isError: false, paineis: dados, msg: mensagem };
    }
    return { isError: true, paineis: [], msg: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseObtemPaineisUsuario({ payload }: { payload: any; type: string }) {
  try {
    const { isError, paineis, msg } = yield call(fetchObtemPaineisUsuario, payload);
    if (!isError) {
      yield put(getPaineisUsuarioSuccess({ paineis }));
    } else {
      yield put(authErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(authErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchObtemPaineisUsuario() {
  yield takeEvery(GET_PAINEIS_USUARIO_INIT, parseObtemPaineisUsuario);
}

export default function* rootSaga() {
  yield all([
    fork(handleGetUserData),
    fork(handleAuthStateChange),
    fork(watchObtemDadosEmpresa),
    fork(watchObtemPaineisEmpresaAtual),
    fork(watchObtemPaineisUsuario),
  ]);
}
